import googleTagManager from "@analytics/google-tag-manager";
import Analytics, { AnalyticsInstance } from "analytics";

class AnalyticsService {
    private static instance: AnalyticsService;
    private analytics: AnalyticsInstance | null = null;

    private constructor() {
        this.initializeAnalytics();
    }

    public static getInstance(): AnalyticsService {
        if (!AnalyticsService.instance) {
            AnalyticsService.instance = new AnalyticsService();
        }
        return AnalyticsService.instance;
    }

    private initializeAnalytics(): void {
        try {
            this.analytics = Analytics({
                app: "psc-customer-map",
                plugins: [
                    googleTagManager({
                        containerId: "GTM-WW9J8ZG",
                    }),
                ],
            });
        } catch (error) {
            console.error("Failed to initialize analytics:", error);
        }
    }

    public track(eventName: string, properties?: Record<string, any>): void {
        if (this.analytics) {
            this.analytics.track(eventName, properties).catch((error) => {
                console.error("Analytics tracking failed:", error);
            });
        }
    }

    public page(pageName?: string, properties?: Record<string, any>): void {
        if (this.analytics) {
            this.analytics
                .page({
                    name: pageName,
                    ...properties,
                })
                .catch((error) => {
                    console.error("Analytics page tracking failed:", error);
                });
        }
    }

    public identify(userId: string, traits?: Record<string, any>): void {
        if (this.analytics) {
            this.analytics.identify(userId, traits).catch((error) => {
                console.error("Analytics identify failed:", error);
            });
        }
    }

    public isInitialized(): boolean {
        return this.analytics !== null;
    }
}

export default AnalyticsService;
